import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["isRoot"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N30 } from '@atlaskit/theme/colors';
export var indentBase = "var(--ds-space-300, 25px)";
var treeRowContainerStyles = css({
  display: 'flex',
  borderBlockEnd: "1px solid ".concat("var(--ds-border, ".concat(N30, ")"))
});

/**
 * __Tree row container__
 */
export var TreeRowContainer = function TreeRowContainer(props) {
  return jsx("div", _extends({
    role: "row",
    css: treeRowContainerStyles
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props));
};
var commonCellElementStyles = css({
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  // indentBase is re-used elsewhere and is primarily used as positive value; we need to negate it here
  marginInlineStart: "calc(".concat(indentBase, " * -1)")
});
var commonChevronContainerStyles = css({
  // Aligns position:absolute chevron button with the adjacent text. Any future visual breaking changes
  // should consider setting this to `-2px` for better alignment, or refactor completely
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  marginBlockStart: -3
});
/**
 * __Chevron container__
 *
 * A wrapper container around the expand table tree button.
 */
export var ChevronContainer = function ChevronContainer(props) {
  return jsx("span", _extends({}, props, {
    css: [commonCellElementStyles, commonChevronContainerStyles]
  }));
};
var loadingItemContainerStyles = css({
  width: '100%'
});
var paddingLeftStyles = css({
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
  paddingInlineStart: '50%'
});
/**
 * __Loader item container__
 *
 * A loader item container.
 */
export var LoaderItemContainer = function LoaderItemContainer(_ref) {
  var isRoot = _ref.isRoot,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx("span", _extends({
    css: [commonCellElementStyles, loadingItemContainerStyles, isRoot && paddingLeftStyles]
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props));
};